module.exports = __webpack_public_path__ + "img/MPM Logo Login.13d699f4.png";